import React from 'react'
import { node } from 'prop-types'

function GroupContainer({ children }) {
  return <div className="modal__group-container">{children}</div>
}

GroupContainer.propTypes = {
  children: node.isRequired,
}

export default GroupContainer
